
const htmlWrapper = `<!DOCTYPE html>
<html>
  <head><title>Faktura - Štampa</title></head>
  <body style="margin:0;padding:0"><div id="print-content" style="width: 100% !important;margin: 0 !important;padding: 0.5in 0.5in !important;"></div></body>
</html>`;

function amountToSerbianWords(amount) {
    if (amount === null || amount === undefined || amount === "") return "";
    const n = Number(String(amount).replace(",", "."));
    if (Number.isNaN(n)) return "";
    const din = Math.floor(Math.abs(n));
    const para = Math.round((Math.abs(n) - din) * 100);
    const ones = ["nula","jedan","dva","tri","četiri","pet","šest","sedam","osam","devet","deset","jedanaest","dvanaest","trinaest","četrnaest","petnaest","šesnaest","sedamnaest","osamnaest","devetnaest"];
    const tens = ["","","dvadeset","trideset","četrdeset","pedeset","šezdeset","sedamdeset","osamdeset","devedeset"];
    const hundreds = ["","sto","dvesta","trista","četiristo","petsto","šeststo","sedamsto","osamsto","devetsto"];
    function twoDigits(x) {
        if (x < 20) return ones[x];
        return (tens[Math.floor(x/10)] + (x % 10 ? ones[x % 10] : "")).trim();
    }
    function threeDigits(x) {
        if (x === 0) return "";
        if (x < 100) return twoDigits(x);
        return (hundreds[Math.floor(x/100)] + (x % 100 ? twoDigits(x % 100) : "")).trim();
    }
    function toWords(x) {
        if (x === 0) return "nula";
        const mil = Math.floor(x / 1000000);
        const th  = Math.floor((x % 1000000) / 1000);
        const rem = x % 1000;
        const parts = [];
        if (mil) parts.push(mil === 1 ? "milion" : threeDigits(mil) + "miliona");
        if (th)  parts.push(th  === 1 ? "hiljadu" : threeDigits(th) + "hiljada");
        if (rem) parts.push(threeDigits(rem));
        return parts.join("").trim();
    }
    const dinarWord = din === 1 ? "dinar" : "dinara";
    let out = toWords(din) + dinarWord;
    if (para > 0) out += "i" + toWords(para) + "para";
    return n < 0 ? "minus" + out : out;
}

const getLogoUrl = (logoPath) => {
    if (!logoPath) return null;
    if (/^https?:\/\//i.test(logoPath)) return logoPath;
    let normalized = String(logoPath).replace(/\\/g, '/');
    normalized = normalized.replace(/^[Cc]:\/Dokumenta\//i, '');
    normalized = normalized.replace(/^\/+/, '');
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodeURI(normalized)}`;
};

export default function handlePrintInvoice(podaci) {
    let htmlContent = podaci.htmlContent;

    const logoUrl = getLogoUrl(podaci.logoPath);
    if (logoUrl) {
        htmlContent = htmlContent.replace('{{LOGO_URL}}', logoUrl);
    } else {
        htmlContent = htmlContent.replace('<img alt="Logo" src="{{LOGO_URL}}">', '');
    }

    if (htmlContent.includes('{{SLOVIMA}}')) {
        const rsdAmount = (podaci.UkupnoZaNaplatu ?? 0) * (podaci.Kurs ?? 1);
        htmlContent = htmlContent.replace('{{SLOVIMA}}', amountToSerbianWords(rsdAmount));
    }

    const printWindow = window.open('', '_blank', 'width=1000,height=700');
    printWindow.document.open();
    printWindow.document.write(htmlWrapper);
    printWindow.document.close();

    const printContainer = printWindow.document.getElementById('print-content');
    printContainer.innerHTML = htmlContent;

    setTimeout(() => {
        printWindow.focus();
        printWindow.print();
    }, 500);
}